<p>edit-user-dialog works!</p>
